import { render, staticRenderFns } from "./CommunityPage.vue?vue&type=template&id=0441e28e&scoped=true&"
import script from "./CommunityPage.vue?vue&type=script&lang=ts&"
export * from "./CommunityPage.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityPage.vue?vue&type=style&index=0&id=0441e28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0441e28e",
  null
  
)

export default component.exports